import './PrivecyCode.css';

import React, { useContext, useEffect, useState, useMemo, useRef } from "react";

import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
//import { Navigate } from "react-router-dom"
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function PrivecyCode() {
    const location = useLocation();
    let navigate = useNavigate();
    useEffect(() => { 
    }, []);


    const [progress, setProgress] = useState(false);
    const [progress2, setProgress2] = useState(false);
    const [mobileNumber, setMobileNumber] = useState(location.state ? location.state.mobile : "")
    //const [code, setCode] = useState("");
    const [time, setTime] = useState({});
    const [seconds, setSeconds] = useState(60 * 2);
    const [timer, setTimer] = useState(0);
    const [form, setForm] = useState({ input1: "", input2: "", input3: "", input4: "" })
   
    const secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }
    const input1 = useRef(null)
    const input2 = useRef(null)
    const input3 = useRef(null)
    const input4 = useRef(null)

    useEffect(() => {
        //document.body.classList.remove('bodyBackGround');
        let timeLeftVar = secondsToTime(seconds);
        setTime(timeLeftVar);
        setTimer(setInterval(countDown, 1000));
    }, []);




    const countDown = () => {
        setSeconds(s => {
            let seconds = s - 1;
            if (seconds <= 0) {
                clearInterval(timer);
                //Navigate('/PasswordRecovery');
                seconds = 0
            }
            setTime(secondsToTime(seconds));
            setSeconds(seconds);
            //console.log('seconds',seconds)          
            return seconds;
        });
    }



    const handleChangeInput = event => {
        const { value, maxLength } = event.target;
        const message = value.slice(0, maxLength);
        //let formState = this.state.form;
        //formState[event.target.id] = message;
        setForm({ ...form, [event.target.id]: message });

        if (event.target.value.length === event.target.maxLength) {
            if (event.target.id == "input1")
                input2.current.focus();
            else if (event.target.id == "input2")
                input3.current.focus();
            else if (event.target.id == "input3")
                input4.current.focus();
        }
    };

    const resend = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (mobileNumber == '') {
            navigate('/login');
            //toast.error('شماره موبایل را وارد فرمایید');
            return;
        }
        setProgress2(true);
        await noronServices.RequestVerifyCode(mobileNumber)
            .then(({ data }) => {
                setProgress2(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                } else {
                    toast.dark('پیامک جدید برای شما فرستاده شد');
                }
            })
            .catch(err => {
                setProgress2(false);
            })
    }

    const handleAdd = async (e) => {
        e.preventDefault();
        let code = form.input1 + form.input2 + form.input3 + form.input4;
        if (code == '') {
            toast.error('کد را وارد فرمایید');
            return;
        }
        setProgress(true);
        await noronServices.CheckVerifyCode(mobileNumber, code)
            .then(async ({ data }) => {
                setProgress(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                navigate('/PasswordRecoveryChange', { state: { mobile: mobileNumber, code: code } });
            })
            .catch(err => {
                setProgress(false);
            });
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter')
            handleAdd(event);
    }


    return (
        <>
            <div className="container col-xl-10 col-xxl-8 px-4 py-5">
                <div className="row align-items-center g-lg-5 py-5">
                    <div className="col-lg-7 text-center text-lg-start">
                        <h1 className="display-4 fw-bold lh-1 mb-3">رددیاب خودرو نورون</h1>
                        <p className="col-lg-10 fs-4 text-justify-center">
                            کد بازیابی به شماره {mobileNumber} ارسال شده است.
                            کد مذکور را در این بخش وارد فرمایید
                        </p>
                    </div>
                    <div className="col-md-10 mx-auto col-lg-5">
                        <div className="p-4 p-md-5 border rounded-3 bg-light   rowColor " id="containerPrivecyCode">
                            <div className="row">
                                <div className="col">
                                    <div className="d-flex justify-content-center">
                                        <span id="CaptionCode">
                                            کد ارسالی را وارد کنید
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <div className="d-flex justify-content-center" id="GroupInputCode">
                                        <input type="number" maxLength="1" min="0" max="9" pattern="\d*"
                                            value={form.input1} onChange={handleChangeInput} autoFocus
                                            ref={input1} id="input1" />

                                        <input type="number" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
                                            value={form.input2} onChange={handleChangeInput}
                                            ref={input2} id="input2" />

                                        <input type="number" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
                                            value={form.input3} onChange={handleChangeInput}
                                            ref={input3} id="input3" />

                                        <input type="number" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}"
                                            value={form.input4} onChange={handleChangeInput}
                                            ref={input4} id="input4" />
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <div className="d-flex justify-content-center">
                                        <span id="CaptionTimer"> {time.s} : {time.m}</span>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <button className="w-100 btn btn-lg btn-primary " onClick={handleAdd}>
                                        <span>تائید&nbsp;&nbsp;&nbsp;</span>
                                        {progress &&
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>}
                                    </button>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <div className="d-flex justify-content-center" id="LinkCode">
                                        {seconds == 0 && <Link to="" id="resendCode" onClick={resend}>ارسال مجدد
                                            {progress2 &&
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>}
                                        </Link>}
                                        <Link id="changeNumber" to="/PasswordRecovery">( تغییر شماره )</Link>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>



        </>
    );
}
